import React, { useState } from "react";
import { BellOutlined, DownOutlined, MenuFoldOutlined,UserOutlined,LogoutOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Dropdown, Avatar, Button,Layout } from 'antd';
import {
    useLocation,
    useNavigate,
    Outlet,
  } from "react-router";
import TabRoute from "./tabroute";

import { useCommonStore } from "@/store/useCommonStore";
import Config from "@/config";
import SideMenu from "@/components/SideMenu";

const { Header, Sider, Content } = Layout;

const MainLayout = ( props ) => {
    const [collapsed,setCollapsed] = useState(false);
    const user = useCommonStore.use.user();
    const logout = useCommonStore.use.logout();
    const winWidth = useCommonStore.use.windowWidth();
    const navigate = useNavigate();
    const items = [
        { label: '用户信息', key: 'info', icon: <UserOutlined /> }, // 菜单项务必填写 key
        { label: '退出登录', key: 'quit', icon: <LogoutOutlined /> },
      ];

    return (
    <div className='flex flex-row h-screen w-screen max-wscreen'>
      <Sider
        //  className="wsc-layout-sider"
        className='max-h-screen overflow-y-auto h-screen' trigger={null} collapsible collapsed={collapsed}>
        <div style={{ cursor: "pointer" }} className={`h-8 mt-4 mr-4 mb-4 ml-4 flex items-center ${collapsed ? 'justify-center' : ''}`} onClick={() => {
          window.location.href = '/';
        }}>
          <img className={`w-6 h-6 ${collapsed ? '' : 'mr-2'}`} src="/asset/images/logo.png"></img>
          {!collapsed ?
            <span className="text-sm text-white font-black hover:text-blue-500  ">
              贯石科技管理平台
            </span> : null}
        </div>
        <SideMenu inlineCollapsed={collapsed} />
        {!collapsed ? <div style={{ width: "200px", backgroundColor: "#001529" }} className='flex flex-col justify-center items-center fixed bottom-0 z-10 h-8'>
          <div className='text-gray-500 text-xs'>贯石科技©2016-2024</div>
          <div className='text-gray-500 text-xs'>{Config.Version}</div>
        </div> : null}
      </Sider>
      <div className='flex flex-col h-screen flex-1'
      style={{width:(winWidth-200)+"px"}}
      >
    <div className="bg-white flex items-center h-12 p-0">
        <div onClick={()=>{setCollapsed(!collapsed)}}>
          {collapsed ? <MenuUnfoldOutlined className='ml-4 hover:text-blue-500' style={{ fontSize: 18 }} /> : <MenuFoldOutlined className='ml-4 hover:text-blue-500' style={{ fontSize: 18 }} />}
        </div>
        {/* 顶部模块菜单 */}
        {/* <TopMenu /> */}
        <div className="flex h-12 justify-end w-full items-center">
          <Button size='small'
           onClick={() => {
            navigate(Config.RoutePrefix + "/export/list");
           }}
          >导出记录表</Button>
          <div className="pt-0 pr-3 pb-0 pl-3 h-full flex items-center">
            <BellOutlined />
          </div>
          <div className="pt-0 pr-3 pb-0 pl-3 h-full flex items-center">

            <Avatar 
              size={28}
              className="wsc_header-avatar border-2 border-gray-200 shadow-md hover:shadow-lg transition-shadow cursor-pointer" 
              src={user?.HeadImgUrl ? `${Config.ApiHost}${user.HeadImgUrl}` : null}
              icon={<UserOutlined />}
            />
            <Dropdown menu={{
              items, onClick: ({ key }) => {
                switch (key) {
                  case "info":
                    navigate(Config.RoutePrefix + "/profile/settings");
                    break;
                  case "quit":
                    logout();
                    break;
                }
              }
            }} className='flex items-center pr-1' >
              <a className="text-blue-500 ml-2 text-sm" onClick={e => e.preventDefault()}>
                <span className='mr-1'>{user?.Name}</span> <DownOutlined />
              </a>
            </Dropdown>
          </div>
        </div>
      </div>
      <TabRoute {...props}>
      </TabRoute>
      </div>
    </div>);
}

export default MainLayout;